import React from 'react';
import { Container } from 'react-bootstrap';
import './RegattaUnderConstruction.css';

export function RegattaUnderConstruction() {
    return (
        <Container fluid className="regatta-lock-page py-5">
            <section className="regatta-lock-hero" role="status" aria-live="polite">
                <p className="regatta-lock-eyebrow">Public Access Paused</p>
                <h1>Regatta Under Construction</h1>
                <p className="regatta-lock-copy">
                    The timetable and draw are temporarily hidden while officials prepare this regatta.
                    Please check back soon.
                </p>
                <div className="regatta-lock-badges">
                    <span>Timetable updates in progress</span>
                    <span>Draw setup in progress</span>
                </div>
            </section>
        </Container>
    );
}
